import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `${window.location.origin}/pdf.worker.min.js`;

console.log("PDF.js version:", pdfjs.version);
console.log("Worker URL:", pdfjs.GlobalWorkerOptions.workerSrc);